(function () {
	'use strict';
	$(document).ready(function () {
		const isLangSwitcherOpen = reactive(false);
		const languagesDropdown = document.querySelector('.languages');
		const languagesBtn = document.querySelector('.lang-button');
		isLangSwitcherOpen.listen((newValue) => {
			if (languagesDropdown) languagesDropdown.classList.toggle('open', newValue);
			if (languagesBtn) languagesBtn.classList.toggle('open', newValue);
		});
		languagesBtn.addEventListener('click', () => {
			isLangSwitcherOpen.set((currentVal) => !currentVal);
		});

		clickedOutside('.language-switcher', () => {
			isLangSwitcherOpen.set(false);
		});

		const $header = document.querySelector('header.header');
		$(window).on('scroll', () => {
			$header.classList.toggle('scrolled', window.scrollY >= 120);
		});
	});
}(jQuery));
